import { useState } from 'react';
import { useProtectedAction } from '../hooks/useProtectedAction';

const N8N = 'https://fatima.agenciafalei.com.br/webhook';

// 🔧 LANCAMENTO: trava de feature. Vire para false quando o extrator
// (versao assincrona com polling no Firebase) estiver 100% e testado.
const EM_BREVE = true;
const MSG_EM_BREVE = 'Estamos deixando a extração de leads mais rápida e estável. Em breve ela volta no ar. 🚀';


export default function ExtractorInstagram() {
  const [nicho, setNicho]       = useState('');
  const [cidade, setCidade]     = useState('');
  const [qty, setQty]           = useState(20);
  const [loading, setLoading]   = useState(false);
  const [status, setStatus]     = useState('');
  const [leads, setLeads]       = useState([]);
  const [selected, setSelected] = useState([]);

  // contaUid vem do hook: o perfil extraído é da conta, não de quem clicou
  const { protect, Modals, logado, temPlano, contaUid } = useProtectedAction(true);

  const extrair = protect(async () => {
    if (!nicho || !cidade) { setStatus('⚠ Preencha nicho e cidade.'); return; }
    setLoading(true); setStatus(''); setLeads([]); setSelected([]);
    try {
      const uid = contaUid || 'guest';
      const r = await fetch(`${N8N}/extrator-instagram`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nicho, cidade, quantidade: qty, uid })
      });
      const data = await r.json();
      if (!data.ok) throw new Error(data.erro || 'Erro na extração');
      setLeads(data.leads || []);
      setStatus('✅ ' + data.total + ' perfis encontrados · ' + data.comNumero + ' com número');
    } catch(e) { setStatus('⚠ ' + e.message); }
    finally { setLoading(false); }
  });

  const toggleSelect = (i) => setSelected(prev => prev.includes(i) ? prev.filter(x=>x!==i) : [...prev, i]);
  const toggleAll = () => setSelected(selected.length === leads.length ? [] : leads.map((_,i)=>i));

  const exportCSV = () => {
    const rows = [['Nome','Username','Telefone','Tipo','Curtidas']];
    leads.forEach(l => rows.push([l.nome, l.username, l.telefone, l.tipo, l.curtidas]));
    const csv = rows.map(r => r.map(v => '"' + (v||'') + '"').join(',')).join('\n');
    const a = document.createElement('a');
    a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    a.download = 'ig_' + nicho + '_' + cidade + '.csv';
    a.click();
  };

  const bloqueado = !logado || !temPlano;

  if (EM_BREVE) return (
    <div style={{ maxWidth: '900px', margin: '0 auto' }}>
      <div style={emBreveCard}>
        <div style={{ fontSize: '40px', marginBottom: '14px' }}>🔧</div>
        <h1 style={{ fontFamily: 'Syne, sans-serif', fontSize: '22px', fontWeight: '800', marginBottom: '10px', color: '#0a0a18' }}>Em breve</h1>
        <p style={{ color: '#52526e', fontSize: '14px', lineHeight: 1.5 }}>{MSG_EM_BREVE}</p>
      </div>
    </div>
  );

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto' }}>
      {Modals}
      <div style={{ marginBottom: '28px' }}>
        <h1 style={{ fontFamily: 'Syne, sans-serif', fontSize: '26px', fontWeight: '800', letterSpacing: '-0.5px', marginBottom: '6px' }}>
          Extrator Instagram
        </h1>
        <p style={{ color: '#52526e', fontSize: '13px' }}>Extrai perfis por nicho e cidade via hashtags.</p>
      </div>

      <div style={card}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
          <div><label style={lbl}>Nicho</label>
            <input value={nicho} onChange={e=>setNicho(e.target.value)} placeholder="Ex: Lash designer, Barbearia" style={inp} /></div>
          <div><label style={lbl}>Cidade</label>
            <input value={cidade} onChange={e=>setCidade(e.target.value)} placeholder="Ex: Curitiba" style={inp} /></div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={lbl}>Quantidade de perfis</label>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '8px', marginTop: '6px' }}>
            {[20,40,60,100].map(n => (
              <button key={n} onClick={() => setQty(n)} style={{
                padding: '12px 8px', borderRadius: '10px', cursor: 'pointer',
                border: qty===n ? '2px solid #e1306c' : '1.5px solid rgba(0,0,0,0.1)',
                background: qty===n ? 'rgba(225,48,108,0.07)' : '#f8f8fc', textAlign: 'center'
              }}>
                <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '20px', fontWeight: '800', color: '#e1306c' }}>{n}</div>
                <div style={{ fontSize: '10px', color: '#9898b8' }}>perfis</div>
              </button>
            ))}
          </div>
        </div>

        {bloqueado && (
          <div style={{ background: 'rgba(225,48,108,0.06)', border: '1px solid rgba(225,48,108,0.2)',
            borderRadius: '10px', padding: '12px 16px', marginBottom: '16px',
            fontSize: '13px', color: '#e1306c' }}>
            {!logado ? '🔒 Entre para usar o extrator' : '🔒 Faça seu plano para extrair leads do Instagram'}
          </div>
        )}

        {status && (
          <div style={{ padding: '10px 14px', borderRadius: '9px', marginBottom: '14px', fontSize: '12px', fontFamily: 'monospace',
            background: status.startsWith('✅') ? 'rgba(16,185,129,0.08)' : 'rgba(239,68,68,0.08)',
            color: status.startsWith('✅') ? '#059669' : '#dc2626',
            border: '1px solid ' + (status.startsWith('✅') ? 'rgba(16,185,129,0.2)' : 'rgba(239,68,68,0.2)') }}>{status}</div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button onClick={extrair} disabled={loading} style={{
            background: loading ? '#9898b8' : 'linear-gradient(135deg, #e1306c, #c13584)',
            color: '#fff', border: 'none', borderRadius: '10px',
            padding: '11px 28px', fontSize: '14px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer'
          }}>
            {loading ? '⟳ Extraindo...' : bloqueado ? '🔒 ' + (!logado ? 'Entrar para extrair' : 'Ver planos') : 'Extrair do Instagram →'}
          </button>
        </div>
      </div>

      {leads.length > 0 && (
        <div style={{ ...card, marginTop: '20px', padding: 0, overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '1px solid rgba(0,0,0,0.07)',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '14px' }}>
              {'📸 ' + leads.length + ' perfis extraídos'}
            </span>
            <button onClick={exportCSV} style={btnGhost}>{'↓ CSV'}</button>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr style={{ background: '#f8f8fc' }}>
                <th style={th}><input type="checkbox" checked={selected.length===leads.length} onChange={toggleAll} /></th>
                <th style={th}>Perfil</th><th style={th}>Telefone</th><th style={th}>Tipo</th><th style={th}>Curtidas</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((l,i) => (
                <tr key={i} style={{ borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                  <td style={td}><input type="checkbox" checked={selected.includes(i)} onChange={()=>toggleSelect(i)} /></td>
                  <td style={td}>
                    <div style={{ fontWeight: '500' }}>{l.nome}</div>
                    <a href={l.perfil} target="_blank" rel="noopener noreferrer"
                      style={{ fontSize: '11px', color: '#e1306c', textDecoration: 'none' }}>{l.username}</a>
                  </td>
                  <td style={{ ...td, fontFamily: 'monospace' }}>{l.telefone || <span style={{ color: '#c4c4d4' }}>sem número</span>}</td>
                  <td style={td}>
                    {l.telefone && <span style={{ padding: '2px 8px', borderRadius: '6px', fontSize: '10px', fontWeight: '600',
                      background: l.tipo==='Celular' ? 'rgba(16,185,129,0.1)' : 'rgba(245,158,11,0.1)',
                      color: l.tipo==='Celular' ? '#059669' : '#d97706' }}>{l.tipo}</span>}
                  </td>
                  <td style={td}>{'❤️ ' + l.curtidas}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const emBreveCard = { background: '#fff', border: '1px solid rgba(225,48,108,0.25)', borderRadius: '16px', padding: '48px 32px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', maxWidth: '460px', margin: '60px auto', textAlign: 'center' };
const card = { background: '#fff', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '14px', padding: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' };
const lbl = { fontSize: '11px', fontWeight: '700', color: '#52526e', textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: 'monospace', display: 'block', marginBottom: '6px' };
const inp = { width: '100%', padding: '10px 12px', borderRadius: '9px', border: '1.5px solid rgba(0,0,0,0.1)', fontSize: '14px', background: '#f8f8fc', outline: 'none', boxSizing: 'border-box', fontFamily: 'DM Sans, sans-serif', color: '#0a0a18' };
const btnGhost = { border: '1.5px solid rgba(0,0,0,0.1)', background: 'none', borderRadius: '8px', padding: '7px 14px', fontSize: '12px', cursor: 'pointer', color: '#52526e' };
const th = { padding: '10px 14px', textAlign: 'left', fontSize: '10px', fontWeight: '700', color: '#9898b8', textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: 'monospace' };
const td = { padding: '11px 14px' };